<template>

	<div style="position: relative;">
		<div @click="show=!show" style="border:1px solid #ccc !important;;padding: 0px 15px;border-radius: 4px;width: 270px;line-height: 29px;cursor: pointer;">
			{{time||placeholder}}
		</div>
		
		
		<el-collapse-transition>
			<div class="select-box" v-if="show">
				<div
					style="padding:10px 10px;display: flex;align-items: center;justify-content: space-between;font-size: 12px;border-bottom: 1px solid #ccc;">
					<el-link :underline="false" type="primary" @click="confirm">确定</el-link>
					<el-link :underline="false" @click="show=false">取消</el-link>
				</div>
				<div style="display: flex;align-items: center;height: 80rpx;">
					<div style="flex:1;display: flex;align-items: center;justify-content: center;font-weight: bold;" v-if="type==='day'">天</div>
					<div style="flex:1;display: flex;align-items: center;justify-content: center;font-weight: bold;" v-if="type==='day'">时</div>
					<div style="flex:1;display: flex;align-items: center;justify-content: center;font-weight: bold;">分</div>
					<div style="flex:1;display: flex;align-items: center;justify-content: center;font-weight: bold;">秒</div>
				</div>
				<div style="flex-1;display: flex;flex-direction: row;">
					<div style="flex:1;height: 320px;overflow-y: scroll;box-sizing: border-box;" class="scroll-row row-d" v-if="type==='day'">
						<div class="scroll-row-item" v-for="i in 1001" :class="(i-1)===d?'scroll-row-item-active':''"
							@click="timeChange('d',(i-1))" @scroll="scroll">
							{{i-1}}
						</div>
					</div>
					<div style="flex:1;height: 320px;overflow-y: scroll;box-sizing: border-box;" class="scroll-row row-h" v-if="type==='day'">
						<div class="scroll-row-item " v-for="i in 25" :class="(i-1)===h?'scroll-row-item-active':''"
							@click="timeChange('h',(i-1))">
							{{i-1}}
						</div>
					</div>
					<div style="flex:1;height: 320px;overflow-y: scroll;box-sizing: border-box;" class="scroll-row row-m">
						<div class="scroll-row-item" v-for="i in 61" :class="(i-1)===m?'scroll-row-item-active':''"
							@click="timeChange('m',(i-1))">
							{{i-1}}
						</div>
					</div>
					<div style="flex:1;height: 320px;overflow-y: scroll;box-sizing: border-box;" class="scroll-row row-s">
						<div class="scroll-row-item" v-for="i in 61" :class="(i-1)===s?'scroll-row-item-active':''"
							@click="timeChange('s',(i-1))">
							{{i-1}}
						</div>
					</div>
				</div>
			</div>
		</el-collapse-transition>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				show: false,
				h: 0,
				d: 0,
				m: 0,
				s: 0,
				time: ''
			}
		},
		props: {
			date: [String, Number],
			placeholder: {
				type: String,
				default: '请输入'
			},
			type:{
				type:String,
				default:'day'
			}
		},
		watch: {
			date(n, v) {
				this.formatDate(n)
			},
			show(n,v){
				if(n){
					setTimeout(()=>{
						if(this.type==='day'){
							if(document.querySelector('.row-d')){
								let selectWarp = document.querySelector('.row-d')
								selectWarp.scrollTop = this.d*25.9
							}
							if(document.querySelector('.row-h')){
								let selectWarp = document.querySelector('.row-h')
								selectWarp.scrollTop = this.h*25.9
							}
						}
						
						if(document.querySelector('.row-m')){
							let selectWarp = document.querySelector('.row-m')
							selectWarp.scrollTop = this.m*25.9
						}
						if(document.querySelector('.row-s')){
							let selectWarp = document.querySelector('.row-s')
							selectWarp.scrollTop = this.s*25.9
						}
					},200)
				}
			}
		},
		mounted() {
			this.formatDate(this.date)
			this.$nextTick(()=>{
				if(document.querySelector('.scroll-row')){
					let selectWarp = document.querySelector('.scroll-row')
					selectWarp.addEventListener('scroll',this.scroll)
				}
			})
		},
		methods: {
			formatDate(n){
				if (n) {
					console.log(n)
					if(this.type==='day'){
						this.d = Math.floor(n / (24 * 3600))
						let l1 = n % (24 * 3600)
						this.h = Math.floor(l1 / 3600)
						let l2 = l1 % 3600
						this.m = Math.floor(l2 / 60)
						let l3 = l2 % 60
						this.s = Math.floor(l3 % 60)
						this.time = this.d + '天' + this.h + '时' + this.m + '分' + this.s + '秒'
					}else{
						this.m = Math.floor(n / 60)
						this.s = Math.floor(n % 60)
						this.time = this.m + '分' + this.s + '秒'
					}
				}else{
					return this.time = '0秒'
				}
			},
			scroll(e){
				let selectWarp = document.querySelector('.scroll-row')
			},
			aaa(e) {
				console.log(e.path.findIndex(item => item === 'div.select-box'))
			},
			timeChange(type, value) {
				if (type == 'd') {
					this.d = value
					if(document.querySelector('.row-d')){
						let selectWarp = document.querySelector('.row-d')
						selectWarp.scrollTop = this.d*25.9
					}
				} else if (type === 'h') {
					this.h = value
					if(document.querySelector('.row-h')){
						let selectWarp = document.querySelector('.row-h')
						selectWarp.scrollTop = this.h*25.9
					}
				} else if (type === 'm') {
					this.m = value
					if(document.querySelector('.row-m')){
						let selectWarp = document.querySelector('.row-m')
						selectWarp.scrollTop = this.m*25.9
					}
				} else {
					this.s = value
					if(document.querySelector('.row-s')){
						let selectWarp = document.querySelector('.row-s')
						selectWarp.scrollTop = this.s*25.9
					}
				}
			},
			confirm() {
				console.log(this.d + '天' + this.h + '时' + this.m + '分' + this.s + '秒')
				let date = 0
				if(this.type==='day'){
					 date = (this.d * 24 * 60 * 60) + (this.h * 60 * 60) + this.m * 60 + this.s
				}else{
					 date = this.m * 60 + this.s
				}
				
				console.log(date)
				this.$emit('confrim', date)
				this.show = false
			}
		}
	}
</script>

<style scoped>
	.select-box {
		width: 300px;
		position: absolute;
		top: 40rpx;
		left: 0;
		background-color: #ffffff;
		border: 1px solid #ccc;
		display: flex;
		flex-direction: column;
		font-size: 14px;
		z-index: 9999;
		border-radius: 3px;
		color: #000
	}

	.scroll-row::-webkit-scrollbar {
		width: 5px;
		background-color: #f1f1f1;
	}

	.scroll-row-item {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 2px;
		color: #aaa;
		line-height: 22px;
		cursor: pointer;
	}

	.scroll-row-item-active {
		color: #409EFF;
	}

	.scroll-row-item:hover {
		background-color: #f1f1f1;
	}
</style>